import React from 'react';

import Input from '../input/input.jsx';

const Cpt = ({disabled, err, onChange, onBlur, defaultValue, onActualChange}) => (
    <Input
        type="number"
        disabled={disabled}
        onBlur={onBlur}
        err={err}
        maxLength={12}
        defaultValue={defaultValue}
        onActualChange={onActualChange}
        onChange={onChange}
        placeholder="请输入手机号"
        verify={v => {
            if (!v.length) {
                throw new Error('请输入手机号');
            } else if (!v.startsWith('1') || v.length > 12) {
                throw new Error('手机号格式不正确');
            }
            return true;
        }}
    />
);

export default Cpt;
